<dx-popup
  width="680"
  height="600"
  [visible]="isVisible"
  (onHiding)="closePopup()"
  title="Réduction du nombre de contenants à livrer"
>
  <div id="container">

    <div class="dialog-line">
      <div class="label">
        Unité de production
      </div>
      <div class="value custom-button-container-right">
        <yo-lookup
          [data]="parametrageList"
          [selectedItem]="selectedParametrage?.siteId"
          (onValueChange)="onSelectSite($event)"
          [disabled]="isCopy"
          key="siteId"
          displayValue="siteLibelle">
        </yo-lookup>
        <yo-button
          id="openCopyOptionsButton"
          [theme]="ButtonThemeEnum.DEFAULT_INNER"
          iconClass="fas fa-copy"
          tooltip="Copier le paramétrage"
          [disabled]="isCopy"
          (onClick)="toggleCopyOptions(true)">
        </yo-button>
      </div>
    </div>

    <ng-container *ngIf="!isCopy">
      <yo-parametre_calcul_conditionnement
        [parametreCalculConditionnement]="selectedParametrage">
      </yo-parametre_calcul_conditionnement>

      <div class="custom-button-container-right">
        <yo-button
          iconClass="fa fa-save"
          [theme]="ButtonThemeEnum.SAVE"
          (onClick)="save()">
        </yo-button>
      </div>
    </ng-container>

    <ng-container *ngIf="isCopy" id="container">

      <yo-list
        id="copyList"
        [data]="siteListAvailableForCopy"
        (onValueChange)="onSelectSiteDestination($event)"
        selectionMode="all"
        searchEnabled="true">
      </yo-list>

      <div class="custom-button-container-right">

        <yo-button
          iconClass="fa fa-check"
          [theme]="ButtonThemeEnum.VALIDATE_INNER"
          label="Valider la copie"
          [disabled]="!selectedSiteDestinationList?.length"
          (onClick)="applyCopy()">
        </yo-button>

        <yo-button
          iconClass="fa fa-times"
          [theme]="ButtonThemeEnum.CANCEL_INNER"
          label="Retour"
          (onClick)="toggleCopyOptions(false)">
        </yo-button>
      </div>

    </ng-container>
  </div>

</dx-popup>
